import { Component, OnInit, Input } from '@angular/core';
import * as L from 'leaflet';
import { Router } from '@angular/router';

@Component({
  selector: 'app-leaflet-map',
  templateUrl: './leaflet-map.component.html',
  styleUrls: ['./leaflet-map.component.scss'],
  standalone: true,
imports: []
})
export class LeafletMapComponent implements OnInit {
  @Input() allClients: any[];

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.displayMap();
  }

  displayMap(): void {
    const map = L.map('map').setView([0, 0], 3); // Set default view
    console.log('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png','dfss');
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors'
    }).addTo(map);

    const indiaBounds = [[8, 68], [37, 98]];
    const markerIcon = L.icon({
      iconUrl: 'assets/marker-icon.png', // Adjust the path as per your project structure
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      tooltipAnchor: [16, -28],
      shadowSize: [41, 41]
    });
    console.log(L.marker,'marker');
    map.fitBounds(indiaBounds);

    this.allClients.forEach(client => {
      const latitude = client.latitude;
      const longitude = client.longitude;

      const marker = L.marker([latitude, longitude],{ icon: markerIcon}).addTo(map);
      const bindPopupAndNavigate = (clientId: string, clientName: string) => {
        marker.bindTooltip(`<b>${client.company_name}</b><br> ${client.address_1}<br> ${client.address_2}`)
          .on('click', () => {
            console.log(client.id, client.company_name, "Data Marker")
            this.navigateToAssetsPage(client.id, client.company_name);
          });
      }
      bindPopupAndNavigate(client.id, client.company_name);

    });
  }

  navigateToAssetsPage(clientId: string, clientName: string): void {
    const navigationExtras = {
      queryParams: {
        admin_client_id: clientId,
        clientName: clientName,
        pageRef: 'leafletMap'
      }
    };
    this.router.navigate(['/device-report-new'],navigationExtras);
  }
}
